import { css } from "@emotion/react";

import theme from "../../styles/theme";
import { blue } from "../../styles/variables";

const { spacing } = theme;

export const disabled = css`
  input:read-only {
    color: rgba(0, 0, 0, 0.38);
  }
`;

export const previewVodButton = {
  borderColor: blue,
  color: blue,
};

export const link = css`
  text-decoration: none;
`;

export const radioVodType = css`
  &.MuiGrid-item {
    padding-top: 0;
  }
`;

export const hidden = css`
  display: none;
`;
